import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../../../shared/api/http'

interface Order {
  id: number
  runner_id: number
  event_id: number
  companion_id?: number
  status: string
  price: number
  target_time?: string
  created_at: string
  updated_at: string
}

const OrderDetailPage: React.FC = () => {
  const { id } = useParams()
  const [data, setData] = useState<Order | null>(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!id) return
    api.get<Order>(`/orders/${id}`)
      .then(res => { setData(res); setError('') })
      .catch(e => setError(e?.message || '加载失败'))
      .finally(() => setLoading(false))
  }, [id])

  if (loading) return <div className="p-4">加载中...</div>
  if (error) return <div className="p-4 text-red-600">{error}</div>
  if (!data) return <div className="p-4">订单不存在</div>

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-2">订单 #{data.id}</h1>
      <div className="text-sm text-gray-600 mb-4">状态：{data.status} · 金额：{data.price} · 目标：{data.target_time || '-'}</div>
      <div className="text-sm text-gray-600">跑者ID：{data.runner_id} · 陪跑员ID：{data.companion_id || '-'}</div>
      <div className="text-sm text-gray-600">赛事ID：{data.event_id}</div>
    </div>
  )
}

export default OrderDetailPage

